import React from 'react';
import { useLanguage } from '../../../context/language/LanguageContext';
import { footerData, socialLinks, contactInfo } from '../../../utils/footerData';
import './Footer.css';

const Footer = () => {
    const { language } = useLanguage();

    // Add console log to debug
    console.log('Current language in Footer:', language);
    console.log('Footer content:', footerData[language]);

    const content = footerData[language];

    if (!content) {
        console.error('Footer content not found for language:', language);
        return null;
    }

    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-content">
                    {/* Contact Information */}
                    <div className="footer-section">
                        <h3 className="footer-heading">{content.contactUs}</h3>
                        <div className="contact-item">
                            <span className="material-icons">phone</span>
                            <a href={`tel:${contactInfo.phone}`}>{content.phone}</a>
                        </div>
                        <div className="contact-item">
                            <span className="material-icons">email</span>
                            <a href={`mailto:${contactInfo.email}`}>
                                {content.email}
                            </a>
                        </div>
                    </div>

                    {/* Address with Map Link */}
                    <div className="footer-section">
                        <h3 className="footer-heading">{content.location}</h3>
                        <a
                            href={contactInfo.mapUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="location-link"
                        >
                            <span className="material-icons">location_on</span>
                            <span>
                {content.address}<br/>
                                {content.viewMap}
              </span>
                        </a>
                    </div>

                    {/* Social Media Links */}
                    <div className="footer-section">
                        <h3 className="footer-heading">{content.followUs}</h3>
                        <div className="social-links">
                            {socialLinks.map((social) => (
                                <a
                                    key={social.name}
                                    href={social.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="social-link"
                                >
                                    <i className={social.icon}></i>
                                </a>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Copyright and Development Credit */}
                <div className="footer-bottom">
                    <div className="copyright">
                        © {new Date().getFullYear()} {content.address}. {content.rights}
                    </div>
                    <div className="developer-credit">
                        {content.developedBy}{' '}
                        <a
                            href=""
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            StudiVert
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;